import React, { Component } from 'react';
import { CloseOutlined, UserOutlined } from '@ant-design/icons';
import { Upload, Modal, Tooltip, Button, Spin, Divider, Checkbox, Avatar, Empty } from 'antd';
import moment from 'moment';
import networkList from '../../../../constants/networkList';
import postService from '../../../../services/httpService';
import otmpostService from '../../../../services/otmhttpService';
import Storage from './../../../../services/local-store';
import userTrackService from './../../../../services/usertrack-service';
import { financialClearanceSchema } from '../../../../schema/financial-counselling';
import RadioButtonLayer from '../../../../components/FormComponent/Input/radioButton';
const $ = require('jquery');
let { addFinancialClearance, updateFinancialClearanceinOTMApp, getCounsellorCommentsByPatient } = networkList
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]

class Finanical_clearance extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            'showDocument': false,
            patientDocument: [],
            body: {},
            tbody: [],
            thead: [{
                "key": 's_no',
                'label': '#'
            }, {
                "key": 'document_description',
                'label': 'Document Description'
            }, {
                "key": 'action',
                'label': 'Upload'
            }, {
                "key": 'submited_files',
                'label': 'Submitted Files'
            }],
            fileList: [],
            disable_15days: false,
            latest_counselling_id: null,
            current_counselling_id: null,
            formData: [],
            counselled_by: null,
            counselled_date: null,
            clearance_id: null,
            remarks: null,
            remarks_input: null,
            clearance: null,
            selected_clearance: null,
            commentsArray: []
        }
    }


    componentDidMount() {
        let formSchema = Object.assign({}, financialClearanceSchema);
        this.setState({ formData: formSchema['feilds'] })
        this.initial();
        // setTimeout(() => { this.initial() }, 1000)
    }

    componentWillUnmount() {
        this.setState({
            visible: false,

        });
    }
    componentDidUpdate(prevProps) {

        if (this.props.mydata !== prevProps.mydata) {
            this.initial()
            // this.setState({modal1Visible: true});
            console.log("updated selected countries", this.props.mydata);
        }
    }

    initial() {
        // this.getMasterDocumentTypes();
        const { id, slug } = this.props.match.params
        if (slug === 'patients-history-details') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        } if (slug === 'pending-docs') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        }
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            let tokenData = JSON.parse(Storage.get('current_token'));
            if (tokenData && tokenData['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'add' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'add' })
            }
        }
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            let view = JSON.parse(Storage.get('counselling_view'));
            if (view && view[0]['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'view' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'view' })
            }
        }
    }

    // getMasterDocumentTypes() {
    //     this.setState({ loadding: true })
    //     let { getMasterDocumentTypes } = networkList;
    //     try {
    //         postService(getMasterDocumentTypes, 'GET', {}).then(res => {
    //             if (res['status']) {
    //                 this.setState((state) => ({ 'tbody': res['data'] }));
    //                 this.setState({ loadding: false })
    //                 Storage.store('getMasterDocumentTypes', res['data'])
    //             } else {
    //                 this.setState((state) => ({ 'docTypes': [] }));
    //                 this.setState({ loadding: false })
    //             }
    //         });
    //     } catch (error) {
    //         console.log(error);
    //         this.setState((state) => ({ 'loadding': false }));
    //         Modal.error({
    //             title: 'Error Message',
    //             content: 'Oops, Something is wrong. Please try again.',
    //         })

    //     }
    // }

    getPatientDocumentDetails() {
        this.setState({ loadding: true })
        let { getFinancialClearanceDetails } = networkList;
        const { id, slug } = this.props.match.params
        let tokenData = JSON.parse(Storage.get('current_token'));
        let user_data = JSON.parse(Storage.get('user_data'));
        let view = JSON.parse(Storage.get('counselling_view'));
        let payload = {}

        if (slug === 'patients-history-details') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('13:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                        console.log('disable_15days', disable_15days, days)
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pending-docs') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('pending-docs:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                        console.log('disable_15days', disable_15days, days)
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': parseInt(counselling_id) })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        // add counselling
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            payload = { "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "unit_id": user_data['unitid'], "form_type": "add", "counselling_id": '' }
            this.setState({ "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "patient_name": tokenData['patient_name'], ui_form_type: 'add' })
        }
        // view counselling
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            const params = new URLSearchParams(this.props.location.search);
            let ui_counselling_id = params.get('rid');
            let current_counselling_id = this.props.print_counselling_id || ui_counselling_id || '';
            let disable_15days = null
            if (view && view[0]['counselling_date']) {
                var days = Math.abs((moment(view[0]['counselling_date']).diff(moment(new Date()), 'day')));
                disable_15days = days > 15 ? true : false
                console.log('disable_15days', disable_15days, days)
            } else {
                disable_15days = false
            }
            payload = { "umr_no": view[0]['umr'], "ip_no": view[0]['ip_number'], "unit_id": user_data['unitid'], "form_type": "view", "counselling_id": current_counselling_id }
            this.setState({ "umr_no": view[0]['umr'], "ip_no": view[0]['ip_number'], "patient_name": view[0]['patient_name'], 'disable_15days': disable_15days, ui_form_type: 'view', 'current_counselling_id': current_counselling_id })
        }
        try {
            const Userlogobj = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get Patient Financial Clearance - Request",
                    "date": new Date(),
                    "meta": payload
                }
            }
            userTrackService(Userlogobj);
            postService(getFinancialClearanceDetails, 'POST', { "data": payload }).then(res => {
                const Userlogobjres = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "get Patient Financial Clearance - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res['status']) {
                    this.commentsHistory()
                    let latest_cou_id = res['latest_counselling_id'] ? res['latest_counselling_id'] : null
                    let { formData } = this.state
                    if (res['data'].length > 0) {
                        formData.map((form, key) => {
                            form.data.map((radio, key2) => {
                                if (res['data'][0]['financial_clearance'] === 'yes') {
                                    formData[key]['data'][key2]['value'] = 'Yes'
                                    formData[key]['data'][1]['value'] = null
                                    formData[key]['data'][key2]['disable'] = this.state.disable_15days
                                } else if (res['data'][0]['financial_clearance'] === 'no') {
                                    formData[key]['data'][key2]['value'] = 'No'
                                    formData[key]['data'][0]['value'] = null
                                    formData[key]['data'][key2]['disable'] = this.state.disable_15days
                                }
                            })
                        })
                    } else {
                        formData.map((form, key) => {
                            form.data.map((radio, key2) => {
                                formData[key]['data'][key2]['value'] = null
                                formData[key]['data'][key2]['disable'] = this.state.disable_15days
                            })
                        })
                    }
                    this.setState((state) => ({ formData: formData, 'clearance_id': res['data'].length > 0 ? res['data'][0]['clearance_id'] : null, 'latest_counselling_id': latest_cou_id, 'counselled_by': res['data'].length > 0 ? res['data'][0]['clearance_by'] : null, 'counselled_date': res['data'].length > 0 ? res['data'][0]['updated_at'] || res['data'][0]['created_at'] : null, 'remarks': res['data'].length > 0 ? res['data'][0]['remarks'] : null, 'clearance': res['data'].length > 0 ? res['data'][0]['financial_clearance'] : null }));
                    this.setState({ loadding: false })
                    Storage.store('getPatientDocumentDetails', res['data'])
                } else {
                    this.setState((state) => ({ 'patientDocument': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }

    // deleteConfirm = (filesArray) => {
    //     let This = this
    //     Modal.confirm({
    //         title: `Do you really want to delete these file?`,
    //         content: `This process can't be undone.`,
    //         zIndex: '1022',
    //         okText: "Delete",
    //         cancelText: "Cancel",
    //         onOk: function () {
    //             window.scrollTo({
    //                 top: 50,
    //                 left: 0,
    //                 behavior: 'smooth'
    //             });
    //             This.deleteDocument(filesArray)
    //         },
    //         onCancel() {
    //             console.log('Cancel');
    //         },
    //     });
    // }
    // deleteDocument = (filesArray) => {
    //     this.setState({ loadding: true })
    //     let payload = {}
    //     let { file_uploading_id } = this.state
    //     console.log('filesArray', filesArray.length, filesArray.length > 1 ? "remove" : "update")
    //     if (file_uploading_id) {
    //         payload = { 'file_uploading_id': file_uploading_id.toString(), action_item: filesArray.length > 1 ? "remove" : "update" }
    //         try {
    //             postService('removePatientDocument', 'POST', { "data": payload }).then(res => {
    //                 if (res['status']) {
    //                     Modal.success({
    //                         title: `Success`,
    //                         content: `${res['message']}`,
    //                         zIndex: '1022'
    //                     });
    //                     this.getPatientDocumentDetails()
    //                     this.setState({ loadding: false })
    //                 } else {
    //                     Modal.error({
    //                         title: `Failure`,
    //                         content: `${res['message']}`,
    //                         zIndex: '1022'
    //                     });
    //                     this.setState({ loadding: false })
    //                 }
    //             });
    //         } catch (error) {
    //             console.log(error);
    //             this.setState((state) => ({ 'loadding': false }));
    //             Modal.error({
    //                 title: 'Error Message',
    //                 content: 'Oops, Something is wrong. Please try again.',
    //             })

    //         }
    //     } else {
    //         Modal.error({
    //             title: `Failure`,
    //             content: `Oops, Please try again.`,
    //             zIndex: '1022'
    //         });
    //         this.setState({ loadding: false })
    //     }

    // }
    setModal1Visible(modal1Visible) {
        this.setState({ modal1Visible, remarks_input: null, selected_clearance: null });
    }
    handleChange = (data) => {
        // console.log('fdata:', data)
        let { formData } = this.state
        if (data) {
            // this.submit(data['value'])
            formData.map((form, key) => {
                form.data.map((radio, key2) => {
                    if (data['value'] === 'yes') {
                        formData[key]['data'][key2]['value'] = 'Yes'
                        formData[key]['data'][1]['value'] = null
                    } else if (data['value'] === 'no') {
                        formData[key]['data'][key2]['value'] = 'No'
                        formData[key]['data'][0]['value'] = null
                    }
                })
            })
            this.setState({ 'selected_clearance': data['value'], 'formData': formData })
        }
    };

    // 
    fc_submit = () => {
        this.setState({ loadding: true })

        let user_data = null
        let { id, slug } = this.props.match.params;
        let { umr_no, ip_no, body, clearance_id, clearance, selected_clearance, remarks_input, remarks } = this.state
        let clearance_text = selected_clearance || clearance || null
        let remarks_text = remarks_input || null

        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        } else {
            Modal.error({
                title: `Failure`,
                content: `unit in null.`,
                zIndex: '1022'
            });
        }

        if (clearance_text && umr_no && user_data['unitid']) {
            if (remarks_text && remarks_text.length > 12) {
                // var num = body.id;
                // var doc_id = num.toString();
                let payload = {};
                var current_counselling_id = '';
                payload['financial_clearance'] = clearance_text;
                payload['remarks'] = remarks_text;
                payload["umr"] = umr_no;
                // if (body['document_type'] === 'KYC') {
                //     payload["ip_number"]= null;
                // } else {
                payload["ip_number"] = ip_no ? ip_no : null;
                // }
                // payload["document_short_code"]= body.document_short_code;
                // payload["document_id"]= doc_id;
                payload["unit_id"] = user_data['unitid'];

                if (slug === 'patients-history-details') {
                    payload["form_type"] = 'view';
                    let yes = this.props.mydata ? this.props.mydata : false;
                    if (yes) {
                        let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                        payload["counselling_id"] = counselling_id;
                        payload["clearance_id"] = clearance_id ? clearance_id : null;
                    }
                }

                if (slug === 'pending-docs') {
                    payload["form_type"] = 'view';
                    let yes = this.props.mydata ? this.props.mydata : false;
                    if (yes) {
                        let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                        payload["counselling_id"] = counselling_id;
                        payload["clearance_id"] = clearance_id ? clearance_id : null;
                    }
                }

                if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
                    payload["form_type"] = 'add';
                    payload["counselling_id"] = '';
                    payload["clearance_id"] = clearance_id ? clearance_id : null;
                }
                if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
                    const params = new URLSearchParams(this.props.location.search);
                    let ui_counselling_id = params.get('rid');
                    current_counselling_id = this.props.print_counselling_id || ui_counselling_id || '';
                    payload["form_type"] = 'view';
                    payload["counselling_id"] = current_counselling_id ? parseInt(current_counselling_id) : null;
                    payload["clearance_id"] = clearance_id ? clearance_id : null;
                }
                // console.log('fc_payload:', payload);
                // return
                try {
                    postService(addFinancialClearance, 'POST', { 'data': payload }).then(res => {
                        console.log('financial response:', res);
                        if (res.status) {
                            Modal.success({
                                title: `success`,
                                content: `${res.message}`,
                                zIndex: '1022'
                            });
                            this.getPatientDocumentDetails();
                            this.fcOTMApp(umr_no,user_data['unitid'],clearance_text)
                            this.setState({ loadding: false, remarks_input: null })
                        } else {
                            Modal.error({
                                title: `Failure`,
                                content: `${res.message}`,
                                zIndex: '1022'
                            });
                            this.getPatientDocumentDetails();
                            this.setState({ loadding: false, remarks_input: null })
                        }

                    })
                } catch (error) {
                    console.log(error);
                    this.setState((state) => ({ 'loadding': false }));
                    Modal.error({
                        title: 'Error Message',
                        content: 'Oops, Something is wrong. Please try again.',
                    })

                }
            } else {
                Modal.error({
                    title: `Failure`,
                    content: `Please, enter remarks briefly.`,
                    zIndex: '1022'
                });
                this.setState({ loadding: false })
            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Please, Enter mandatory fields`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }
    }

    fcOTMApp = (umr_no,unitid,clearance_text) =>{
        try {
            otmpostService(updateFinancialClearanceinOTMApp, 'POST', {
                "data": {
                "umr": umr_no ? umr_no : null,
                "unit_id": unitid ? unitid : null,
                "financial_clearance": clearance_text ? clearance_text : null
                }
                }).then(res => {
                console.log('otm financial response:', res);
                if (res.status) {
                    // Modal.success({
                    //     title: `success`,
                    //     content: `${res.message}`,
                    //     zIndex: '1022'
                    // });
                    this.setState({ loadding: false })
                } else {
                    // Modal.error({
                    //     title: `Failure`,
                    //     content: `${res.message}`,
                    //     zIndex: '1022'
                    // });
                    this.setState({ loadding: false })
                }

            })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }
    // handle2Change = ({ fileList }) => {
    //     let file = null,
    //         file_type = null,
    //         file_name = null,
    //         file_size = null;
    //     if (fileList) {
    //         fileList.map(async (item, key) => {
    //             file = item.originFileObj;
    //             file_type = item.type;
    //             file_name = item.name;
    //             file_size = item.size;
    //             // check file type
    //             const isJpgOrPngOrPdf = file_type == 'image/png' || file_type == 'image/jpg' || file_type == 'image/jpeg' || file_type == 'application/pdf';
    //             if (!isJpgOrPngOrPdf) {
    //                 Modal.error({
    //                     title: `(${file_name}) is invalid file.`,
    //                     content: `Please, upload the following extensions files (.png/.jpg/.pdf) smaller than 2MB only.`,
    //                     zIndex: '1022'
    //                 });
    //             }
    //             // check file size        
    //             const isLt2M = file_size / 1024 / 1024 < 2;
    //             if (!isLt2M) {
    //                 Modal.error({
    //                     title: `(${file_name}) is invalid file.`,
    //                     content: `Please, upload the file smaller than 2MB only.`,
    //                     zIndex: '1022'
    //                 });
    //             }

    //             if (isJpgOrPngOrPdf && isLt2M) {
    //                 console.log('check', isJpgOrPngOrPdf, isLt2M)
    //                 this.resubmit(file)
    //             }
    //         });
    //     }
    // };

    // resubmit = (file) => {
    //     this.setState({ loadding: true })
    //     let user_data = null
    //     const { id, slug } = this.props.match.params;
    //     if (localStorage.getItem('user_data') !== null) {
    //         user_data = JSON.parse(localStorage.getItem('user_data'))
    //     } else {
    //         Modal.error({
    //             title: `Failure`,
    //             content: `unit in null.`,
    //             zIndex: '1022'
    //         });
    //     }
    //     let { umr_no, ip_no, body, file_uploading_id } = this.state
    //     if (file && umr_no && body && body.id && body.document_short_code && user_data['unitid']) {
    //         var num = body.id;
    //         var doc_id = num.toString();

    //         var current_counselling_id = '';
    //         var form_data = new FormData();
    //         form_data.append('upfile', file);
    //         form_data.append("umr", umr_no);
    //         if (body['document_type'] === 'KYC') {
    //             form_data.append("ip", null);
    //         } else {
    //             form_data.append("ip", ip_no);
    //         }
    //         form_data.append("file_uploading_id", file_uploading_id ? file_uploading_id.toString() : null);
    //         form_data.append("document_short_code", body.document_short_code);
    //         form_data.append("document_id", doc_id);
    //         form_data.append("unit_id", user_data['unitid']);

    //         if (slug === 'patients-history-details') {
    //             form_data.append("form_type", 'view');
    //             let yes = this.props.mydata ? this.props.mydata : false;
    //             if (yes) {
    //                 let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
    //                 form_data.append("counselling_id", counselling_id);
    //             }
    //         }

    //         if (slug === 'pending-docs') {
    //             form_data.append("form_type", 'view');
    //             let yes = this.props.mydata ? this.props.mydata : false;
    //             if (yes) {
    //                 let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
    //                 form_data.append("counselling_id", counselling_id);
    //             }
    //         }

    //         if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
    //             form_data.append("form_type", 'add');
    //             form_data.append("counselling_id", '');
    //         }
    //         if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
    //             current_counselling_id = this.props.print_counselling_id || '';
    //             form_data.append("form_type", 'view');
    //             form_data.append("counselling_id", current_counselling_id);
    //         }
    //         // To check for the values are present or not
    //         // for (var key of form_data.entries()) {
    //         //     console.log(key[0] + ', ' + key[1]);
    //         // }

    //         try {
    //             formDataPostService('fileUpload', 'POST', form_data).then(res => {
    //                 console.log('fileupload response:', res);
    //                 if (res.status) {
    //                     Modal.success({
    //                         title: `success`,
    //                         content: `${res.message}`,
    //                         zIndex: '1022'
    //                     });
    //                     this.getPatientDocumentDetails();
    //                     this.setState({ loadding: false })
    //                 } else {
    //                     Modal.error({
    //                         title: `Failure`,
    //                         content: `${res.message}`,
    //                         zIndex: '1022'
    //                     });
    //                     this.setState({ loadding: false })
    //                 }

    //             })
    //         } catch (error) {
    //             console.log(error);
    //             this.setState((state) => ({ 'loadding': false }));
    //             Modal.error({
    //                 title: 'Error Message',
    //                 content: 'Oops, Something is wrong. Please try again.',
    //                 zIndex: '1022'
    //             })

    //         }
    //     } else {
    //         Modal.error({
    //             title: `Failure`,
    //             content: `Oops, something went wrong. Please try again.`,
    //             zIndex: '1022'
    //         });
    //         this.setState({ loadding: false })
    //     }
    // }
    // onChange(evt, body, item) {
    //     console.log('checkbox', evt.target.checked)
    //     if (evt.target.checked) {
    //         this.checked_true(body);
    //     } else {
    //         this.checked_false(item)
    //     }
    // };
    // checked_true = (body) => {
    //     this.setState({ loadding: true })
    //     let user_data = null
    //     if (localStorage.getItem('user_data') !== null) {
    //         user_data = JSON.parse(localStorage.getItem('user_data'))
    //     } else {
    //         Modal.error({
    //             title: `Failure`,
    //             content: `unit is null.`,
    //             zIndex: '1022'
    //         });
    //     }
    //     let ip = null
    //     let { umr_no, ip_no, latest_counselling_id } = this.state
    //     if (umr_no && body && body.id && user_data['unitid']) {
    //         var num = body.id;
    //         var id = num.toString();

    //         if (body['document_type'] === 'KYC') {
    //             ip = null;
    //         } else {
    //             ip = ip_no;
    //         }
    //         let payload = {
    //             "umr": umr_no,
    //             "ip": ip,
    //             "document_id": id,
    //             "unit_id": user_data['unitid'],
    //             "counselling_id": latest_counselling_id
    //         }
    //         console.log('form_data:', body, payload);
    //         try {
    //             postService('enableFileUpload', 'POST', { 'data': payload }).then(res => {
    //                 console.log('enableFileUpload response:', res);
    //                 if (res.status) {
    //                     // Modal.success({
    //                     //     title: `success`,
    //                     //     content: `${res.message}`,
    //                     //     zIndex: '1022'
    //                     // });
    //                     this.getPatientDocumentDetails();
    //                     this.setState({ loadding: false })
    //                 } else {
    //                     Modal.error({
    //                         title: `Failure`,
    //                         content: `${res.message}`,
    //                         zIndex: '1022'
    //                     });
    //                     this.setState({ loadding: false })
    //                 }

    //             })
    //         } catch (error) {
    //             console.log(error);
    //             this.setState((state) => ({ 'loadding': false }));
    //             Modal.error({
    //                 title: 'Error Message',
    //                 content: 'Oops, Something is wrong. Please try again.',
    //                 zIndex: '1022'
    //             })

    //         }
    //     } else {
    //         Modal.error({
    //             title: `Failure`,
    //             content: `Oops, something went wrong. Please try again.`,
    //             zIndex: '1022'
    //         });
    //         this.setState({ loadding: false })
    //     }
    // }
    // checked_false = (item) => {
    //     this.setState({ loadding: true })
    //     let file_uploading_id = item ? item['file_uploading_id'] : true
    //     if (file_uploading_id) {
    //         let payload = {
    //             "file_uploading_id": item ? item['file_uploading_id'].toString() : null,
    //         }
    //         console.log('form_data:', item, payload);
    //         try {
    //             postService('disableFileUpload', 'POST', { 'data': payload }).then(res => {
    //                 console.log('fileupload response:', res);
    //                 if (res.status) {
    //                     // Modal.success({
    //                     //     title: `success`,
    //                     //     content: `${res.message}`,
    //                     //     zIndex: '1022'
    //                     // });
    //                     this.getPatientDocumentDetails();
    //                     this.setState({ loadding: false })
    //                 } else {
    //                     Modal.error({
    //                         title: `Failure`,
    //                         content: `${res.message}`,
    //                         zIndex: '1022'
    //                     });
    //                     this.setState({ loadding: false })
    //                 }

    //             })
    //         } catch (error) {
    //             console.log(error);
    //             this.setState((state) => ({ 'loadding': false }));
    //             Modal.error({
    //                 title: 'Error Message',
    //                 content: 'Oops, Something is wrong. Please try again.',
    //                 zIndex: '1022'
    //             })

    //         }
    //     } else {
    //         Modal.error({
    //             title: `Failure`,
    //             content: `Oops, something went wrong. Please try again.`,
    //             zIndex: '1022'
    //         });
    //         this.setState({ loadding: false })
    //     }
    // }

    // downloadPatientDocumentsAsPDF() {
    //     this.setState({ loadding: true })
    //     let { downloadPatientDocumentsAsPDF } = networkList;
    //     const { id, slug } = this.props.match.params
    //     let tokenData = JSON.parse(Storage.get('current_token'));
    //     let user_data = JSON.parse(Storage.get('user_data'));
    //     let view = JSON.parse(Storage.get('counselling_view'));
    //     let payload = {}

    //     if (slug === 'patients-history-details') {
    //         let yes = this.props.mydata ? this.props.mydata : false
    //         console.log('13:', this.props.mydata)
    //         if (yes) {
    //             let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
    //             let disable_15days = null
    //             if (umr_no) {
    //                 payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": parseInt(counselling_id) }
    //             }
    //         } else {
    //         }
    //     }
    //     if (slug === 'pending-docs') {
    //         let yes = this.props.mydata ? this.props.mydata : false
    //         console.log('pending-docs:', this.props.mydata)
    //         if (yes) {
    //             let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
    //             let disable_15days = null
    //             if (umr_no) {
    //                 payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": parseInt(counselling_id) }
    //             }
    //         } else {

    //         }
    //     }
    //     // view counselling
    //     if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
    //         const params = new URLSearchParams(this.props.location.search);
    //         let ui_counselling_id = params.get('rid');
    //         let current_counselling_id = this.props.print_counselling_id || ui_counselling_id || '';
    //         payload = { "umr_no": view[0]['umr'], "ip_no": view[0]['ip_number'], "unit_id": user_data['unitid'], "form_type": "view", "counselling_id": parseInt(current_counselling_id) }
    //     }
    //     try {
    //         postService(downloadPatientDocumentsAsPDF, 'POST', { "data": payload }).then(res => {
    //             if (res['status']) {

    //                 let { base_url } = networkList
    //                 fetch(`${base_url}${res['single_file_url']}`)
    //                     .then(response => {
    //                         response.blob().then(blob => {
    //                             let url = window.URL.createObjectURL(blob);
    //                             let a = document.createElement('a');
    //                             a.href = url;
    //                             a.download = res['single_file_url'];
    //                             a.click();
    //                         });

    //                         this.setState({ loadding: false })
    //                     });
    //             } else {
    //                 Modal.error({
    //                     title: 'Failure',
    //                     content: res.message ? res.message : 'Oops, Something is wrong. Please try again.',
    //                     zIndex: 1022
    //                 })
    //                 this.setState({ loadding: false })
    //             }
    //         });
    //     } catch (error) {
    //         console.log(error);
    //         this.setState((state) => ({ 'loadding': false }));
    //         Modal.error({
    //             title: 'Error Message',
    //             content: 'Oops, Something is wrong. Please try again.',
    //         })

    //     }
    // }
    // selectChanges = () => {
    //     console.log('radio')
    // }
    remarks(event) {
        let value = event.target.value;
        this.setState((state) => ({ 'remarks_input': value ? value : null }));
    }
    commentsHistory = (data) => {
        let {umr_no}=this.state
        let This = this
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        try{
        This.setState((state) => ({ loadding: true }), () => {
            postService(getCounsellorCommentsByPatient, 'POST', {
                "data":{
                    "unit_id": user_data['unitid'] ? user_data['unitid'] : null,
                    "umr_no": umr_no ? umr_no : null
                }
            }).then(res => {
                console.log('comments:', res);                
                if (res.status) {                    
                    This.setState((state) => ({ 'loadding': false, 'commentsArray': res['data']}));                    
                } else {
                    This.setState((state) => ({ 'loadding': false, 'commentsArray': [] }));
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                        zIndex: 1022
                    });
                }
            });
        });
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Failure',
            content: "Oops, something went wrong... Please try again.",
            zIndex: 1022
        });
    }        
    }
    render() {
        let { tbody, showDocument, patientDocument, thead, umr_no, ip_no, patient_name, fileList, loadding, hideonHistory, ui_form_type, disable_15days,
            current_counselling_id, latest_counselling_id, formData, counselled_by, counselled_date, modal1Visible, remarks, remarks_input, commentsArray } = this.state
        // let view = JSON.parse(Storage.get('counselling_view'));
        let pat_doc_ids = []
        patientDocument.map((item, key1) => { pat_doc_ids.push(parseInt(item['document_id'])) })
        const { id, slug } = this.props.match.params
        // console.log('curr lat:', this.state.current_counselling_id, this.state.latest_counselling_id)
        return (<React.Fragment>
            <div className="position-sticky" style={{ top: '140px' }}>
                <div className="row mb-2 mx-0">
                    {slug === 'patients-history-details' || slug === 'pending-docs' ? null : <React.Fragment> {showDocument ?
                        <div className={`col-12 mb-2 icon mx-auto p-3 text-center doc-ena`} onClick={() => { this.setModal1Visible(true); this.initial() }}>
                            <small className="pt-2 text-dark">Financial Clearance</small>
                        </div>
                        :
                        <div className={`col-12 mb-2 icon mx-auto p-3 text-center doc-dis`}>
                            <small className="pt-2 text-dark">Financial Clearance</small>
                        </div>
                    }</React.Fragment>}
                    <Modal
                        // title="Upload Documents"
                        centered
                        visible={modal1Visible}
                        // onOk={() => this.includesOK()}
                        // onCancel={() => this.setModal1Visible(false)}
                        width='50%'
                        zIndex='1021'
                        closable={false}
                        maskClosable={false}
                        footer={null}
                    >
                        <Tooltip title='Close'><CloseOutlined type="close" className=" popup-close" onClick={() => this.setModal1Visible(false)} /></Tooltip>
                        {ui_form_type === 'view' && disable_15days == true ?
                            <React.Fragment>
                                <h4 className="text-center">Financial Clearance</h4>
                                <p className="text-center mb-5 text-danger">This counselling has expired, new changes are not allowed</p>
                            </React.Fragment>
                            :
                            <React.Fragment>
                                <h4 className="text-center">Financial Clearance</h4>
                                <p className="text-center mb-5">Select the financial clearance for this patient.</p>
                            </React.Fragment>}
                        {(loadding) && <div className="loadding h-100 w-100" style={{ left: 0 }}> <Spin ></Spin></div>}


                        {/* <div className="row pb-3">
                            <div className="col my-auto">
                                <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_name ? patient_name : '--'}</Tooltip></h6>
                            </div>
                            <div className="col my-auto">
                                <h6 className="mb-0"> <Tooltip title="UMR Number">{umr_no ? umr_no : '--'}</Tooltip></h6>
                            </div>
                            <div className="col my-auto">
                                <h6 className="mb-0"> <Tooltip title="IP Number">{ip_no ? ip_no : '--'}</Tooltip></h6>
                            </div>
                        </div> */}
                        {/* {counselled_by && <h6 className="mb-0 text-center mb-5"> <Tooltip title="Last Updated By">{counselled_by ? counselled_by : ''}</Tooltip> <span className="mx-3">|</span> <Tooltip title="Last Updated at">{counselled_date ? moment(counselled_date).format('DD-MM-YYYY HH:mm') : ''}</Tooltip> <span className="mx-3">|</span> <Tooltip title="Last Remarks">{remarks ? remarks : ''}</Tooltip> </h6>} */}
                        <div className=" row">
                            {formData.map((feild, key) => {
                                if (feild.visible && feild.element === 'radio') {
                                    return <React.Fragment key={key}>
                                        <div className="col-6 mx-auto">{feild.data.map((radio, key) => {
                                            return (<div className="w-50 d-inline-flex radio-button">
                                                <RadioButtonLayer selectdata={radio}
                                                    changedObj={this.state.changedObj}
                                                    {...this.props}
                                                    {...this.state}
                                                    Queuedata={this.state.formData}
                                                    onselectChanges={this.handleChange.bind(this)} />

                                            </div>)
                                        })}
                                            {feild.errors.map((error, eKey) => {
                                                return (
                                                    <small key={eKey} className="form-text text-danger" style={{ bottom: '-15px' }}>{error.message}</small>
                                                );
                                            })}
                                        </div>
                                    </React.Fragment>
                                }
                            })}
                        </div>
                        {!disable_15days && <React.Fragment>
                            <div className="row w-100 mx-auto mt-3">
                                <div class="col-12 p-0">
                                    <textarea placeholder="Enter your remarks..." autoFocus='true' className="textarea" style={{ height: '80px' }} value={remarks_input ? remarks_input : ''} onChange={(event) => this.remarks(event)}></textarea>
                                </div>
                            </div>
                            <div className="text-right">
                                <button className="btn btn-success" onClick={() => { this.fc_submit() }}>Submit</button>
                            </div>
                        </React.Fragment>}
                        <div class="row pt-3">
                            {commentsArray.map((data,key)=>{                                
                                return <div className="col-12 pb-3">
                                    <div class="media">                                       
                                        <div class="align-self-start mr-3">
                                        <Avatar size={50} icon={<UserOutlined />} className="align-middle"/>
                                        </div>
                                        <div class="media-body">
                                        <h6 className='mb-1'><Tooltip title="Created By">{data.created_by}</Tooltip> <span className="mx-3">|</span> <Tooltip title='Created On'><small className="text-muted">{moment(data.created_at).format('DD-MM-YYYY LT')}</small></Tooltip> <span className="mx-3">|</span> <Tooltip title="Comment From"><small className="text-capitalize text-muted"> {data.remarks_from}</small></Tooltip></h6>
                                            <p>{data.remarks}</p>
                                        </div>
                                    </div>
                                </div>
                            })}
                            {commentsArray && commentsArray.length == 0 && <Empty className="mx-auto" description={<span>No history is available for this patient.</span> }/>}
                        </div>
                    </Modal>

                </div>
            </div>
        </React.Fragment>)
    }
}
export default Finanical_clearance;